import { Text } from '@podiumhq/design-system';

const SavingsPill = ({ savings, ...wrapperProps }) => (
  <Text
    backgroundColor="green.lightest"
    borderRadius="40px"
    color="green.dark"
    fontSize="sm"
    fontWeight="medium"
    height="24px"
    lineHeight="24px"
    ml="8px"
    textAlign="center"
    width="95px"
    {...wrapperProps}
  >
    SAVE ${savings}
  </Text>
);

export default SavingsPill;
